// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--14l5w";
export var inner = "footer-module--inner--yV07t";
export var text = "footer-module--text--3oYRn";
export var link = "footer-module--link--1BHEg";
export var socialContainer = "footer-module--socialContainer--3po91";